import { WbButton } from '@agilelab/plugin-wb-platform';
import { FC } from 'react';
import { Box, Typography, makeStyles, useTheme } from '@material-ui/core';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import { useTeamRolesPanelContext } from '../../../context';
import { useOnboardProject } from '../../../hooks';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(4),
    height: '100%',
    width: '100%',
    transition: 'transform 0.3s ease',
    '&:hover $iconContainer': {
      transform: 'translateY(-4px)',
    },
    '&:hover $iconContainer::after': {
      opacity: 1,
    },
  },
  iconContainer: {
    position: 'relative' as const,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 140,
    height: 140,
    minWidth: 100,
    borderRadius: '50%',
    opacity: 0.7,
    backgroundColor: theme.palette.white,
    border: `2px dashed ${theme.palette.info.main}`,
    transition: 'transform 0.3s ease',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '&::after': {
      content: '""',
      position: 'absolute' as const,
      bottom: -18,
      left: '-5%',
      width: '110%',
      height: 16,
      borderRadius: '50%',
      background:
        'radial-gradient(ellipse, rgba(0, 0, 0, 0.12) 0%, transparent 70%)',
      opacity: 0,
      transition: 'opacity 0.3s ease',
    },
  },
  icon: {
    fontSize: 100,
    color: theme.palette.info.main,
    transition: 'transform 0.3s ease',
  },
}));

export const OnboardNoData: FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { isCatalogInfoOwner } = useTeamRolesPanelContext();
  const { loading, handleOnboardProject } = useOnboardProject();

  return (
    <Box className={classes.root}>
      <Typography
        style={{ fontWeight: 700, textAlign: 'center' }}
        variant="body1"
      >
        Team Roles has been enabled on the Witboost Platform
      </Typography>
      <Box className={classes.iconContainer}>
        <OpenInBrowserIcon className={classes.icon} />
      </Box>
      <Typography style={{ textAlign: 'center' }} color="textSecondary">
        {isCatalogInfoOwner
          ? 'Onboard your project to start using Team Roles management and have more control over your team accountabilities.'
          : 'Only the project owner can onboard this project.'}
      </Typography>
      {isCatalogInfoOwner && (
        <Box style={{ marginTop: theme.spacing(2) }}>
          <WbButton
            startIcon={<OpenInBrowserIcon />}
            variant="contained"
            label="Onboard Project"
            loading={loading}
            onClick={handleOnboardProject}
          />
        </Box>
      )}
    </Box>
  );
};
